import { useMutation, useQuery } from "@tanstack/react-query";
import { api } from "api";
import axios from "axios";
import { T_Api_Success_Res } from "./api.types";
import { CashFlowResponse } from "dtos/forecast.dto";

export const foreCastService = {
  useGetDailyForeCast: (appKey: string | undefined) => {
    return useQuery({
      queryKey: ["forecast/daily", appKey],
      queryFn: async () => {
        const res = await api.get(`/application/forecast/${appKey}`);
        return res.data as T_Api_Success_Res<CashFlowResponse[]>;
      },
      enabled: !!appKey,
    });
  },
  usePostForecast: () => {
    return useMutation({
      mutationKey: ["forecast/post"],
      mutationFn: async ({ appKey, reset }: { appKey: string | undefined; reset?: boolean }) => {
        return api.post(`/application/intelligence/statements/forecast/${appKey}`, { reset });
      },
    });
  },
};
